import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'
import {Text} from '@daedalus/atlas/Text'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import {DateAndRoomsText} from '@daedalus/shared/src/search/DateAndRoomsText'

interface HeaderTitleProps {
  placeName?: string
  title?: string
  placeId?: string
}

export interface WidgetHeaderProps extends HeaderTitleProps {
  checkIn?: string
  checkOut?: string
  rooms: string
  hotelNames?: string[]
  hotelIds?: string[]
}

const Container = styled('div')(
  ({theme}) => css`
    margin-bottom: ${theme.layout.spacing.s500}px;
  `
)

const TitleWrapper = styled('div')`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const HeaderSkeleton = () => (
  <Container>
    <SkeletonLoader height={64} />
  </Container>
)

const HeaderTitle = ({title, placeName, placeId}: HeaderTitleProps) => {
  const serachByPlace = placeId || placeName

  if (title) {
    return <Text variant="titleL">{title}</Text>
  } else if (serachByPlace && placeName) {
    return (
      <Text variant="titleL">
        <FormattedMessageWrapper
          id="latestDeals"
          defaultMessage="Latest deals in {placeName}"
          values={{
            placeName
          }}
        />
      </Text>
    )
  } else {
    return (
      <Text variant="titleL">
        <FormattedMessageWrapper
          id="recommendationsTitle"
          defaultMessage="Recommendations"
        />
      </Text>
    )
  }
}

export const WidgetHeader = ({
  placeName,
  checkIn,
  checkOut,
  rooms,
  title,
  placeId
}: WidgetHeaderProps) => {
  return (
    <Container>
      <TitleWrapper>
        <HeaderTitle title={title} placeName={placeName} placeId={placeId} />
      </TitleWrapper>

      <DateAndRoomsText checkIn={checkIn} checkOut={checkOut} rooms={rooms} />
    </Container>
  )
}
